import React, { useCallback } from 'react';

import QRCodeStyling from 'qr-code-styling';

const QrCodePanel = ({ url = '', caption, theme = 'auto' }) => {
  // Callback ref so the QR code renders as soon as the node is in the DOM
  const qrRef = useCallback(
    (node) => {
      if (!node || !url) return;

      // theme pins the dot color for a fixed surface; 'auto' follows the app theme
      const isDark = theme === 'dark' || (theme === 'auto' && document.documentElement.classList.contains('dark'));
      const qrCode = new QRCodeStyling({
        width: 1200,
        height: 1200,
        data: url,
        margin: 0,
        imageOptions: { saveAsBlob: true, hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
        dotsOptions: { type: 'rounded', color: isDark ? '#ffffff' : '#000000', roundSize: true },
        backgroundOptions: { round: 0, color: 'transparent' },
        cornersSquareOptions: { type: 'dot' },
        cornersDotOptions: { type: 'dot' },
        qrOptions: { errorCorrectionLevel: 'L' },
      });

      node.replaceChildren();
      qrCode.append(node);
    },
    [theme, url],
  );

  return (
    // caption spacing only when there is a caption, so captionless embeds center cleanly
    <div className={caption ? 'flex flex-col items-center gap-6 pb-2' : 'flex flex-col items-center'}>
      {/* CSS scales the oversized canvas/SVG down to fill the container */}
      <div
        ref={qrRef}
        className="aspect-square max-h-[260px] w-full max-w-[260px] [&>canvas]:h-full [&>canvas]:w-full [&>svg]:h-full [&>svg]:w-full"
      />
      {caption && <p className="text-center text-xs font-normal leading-normal text-gray-600">{caption}</p>}
    </div>
  );
};

export default QrCodePanel;
